





































import { Component, Vue } from "vue-property-decorator";
import { pusher } from "@/services/PusherClient";
import { userModule } from "@/store/modules/user";

@Component
export default class CriticalLabAlarmListener extends Vue {
  show = false;
  alarm: any = null;

  private channel: any = null;
  private audioCtx: AudioContext | null = null;
  private beepInterval: number | null = null;

  mounted() {
    const unitId = userModule.loginUnitId;
    if (!unitId) return;

    this.channel = pusher.subscribe(`unit.${unitId}`);
    this.channel.bind("critical-value.released", this.onAlarm);

    document.addEventListener("click", this.primeAudio, { once: true });
  }

  beforeDestroy() {
    if (this.channel) {
      this.channel.unbind("critical-value.released", this.onAlarm);
    }
    document.removeEventListener("click", this.primeAudio);
    this.stopBeeping();
  }

  onAlarm(data: any) {
    this.alarm = data;
    this.show = true;
    this.playBeep();
    this.stopBeeping();
    this.beepInterval = window.setInterval(this.playBeep, 10000);
  }

  close() {
    this.show = false;
    this.stopBeeping();
  }

  goToPage() {
    this.close();
    if (this.$route.name !== "pelaporan-hasil-kritis-lab") {
      this.$router.push({ name: "pelaporan-hasil-kritis-lab" });
    }
  }

  private stopBeeping() {
    if (this.beepInterval) {
      clearInterval(this.beepInterval);
      this.beepInterval = null;
    }
  }

  private primeAudio() {
    this.ensureAudio();
  }

  private ensureAudio() {
    if (!this.audioCtx) {
      const AC =
        window.AudioContext || (window as TODO).webkitAudioContext || null;
      if (AC) this.audioCtx = new AC();
    }
    if (this.audioCtx && this.audioCtx.state === "suspended") {
      this.audioCtx.resume().catch(() => undefined);
    }
  }

  private playBeep() {
    this.ensureAudio();
    if (!this.audioCtx || this.audioCtx.state !== "running") return;
    const ctx = this.audioCtx;
    for (let i = 0; i < 3; i++) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "square";
      osc.frequency.value = 880;
      gain.gain.value = 0.15;
      osc.connect(gain);
      gain.connect(ctx.destination);
      const t = ctx.currentTime + i * 0.35;
      osc.start(t);
      osc.stop(t + 0.2);
    }
  }
}
